import HeaderContainer from "./HeaderContainer";
import React from "react";
import ExpenseForm from "../components/ExpenseForm";
import { Container } from "react-bootstrap";
import FooterContainer from "./FooterContainer";

const ExpenseContainer = () => {
    return (
        <>
            <HeaderContainer title="Registro de Gastos"></HeaderContainer>
            <Container>
                <h1 style={{ margin: "15px" }}>Gasto</h1>
                <ExpenseForm />
            </Container>
            <FooterContainer />
        </>
    );
}

export default ExpenseContainer;